import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";

export function NotFoundPage() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 1 }}>
        404
      </Typography>
      <Typography sx={{ mb: 2 }}>Page not found.</Typography>
      <Link component={RouterLink} to="/">
        Go to Home
      </Link>
    </Box>
  );
}
